import { Component, ViewEncapsulation, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { Moment } from 'moment';
import { LanguageService } from 'src/shared/services/language.service';
import { Subscription } from 'rxjs';

export const MONTH_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'atom-month-range',
  templateUrl: './month-range.component.html',
  styleUrls: ['./month-range.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MONTH_FORMATS },
  ],
  encapsulation: ViewEncapsulation.None,
})
export class MonthRangeComponent implements OnInit, OnDestroy {
  @Input() labelStartMonth: string = 'Mes inicial';
  @Input() labelEndMonth: string = 'Mes final';

  @Output() monthRangeSelected = new EventEmitter<{ start: Date, end: Date }>();

  startMonthControl = new FormControl(moment());
  endMonthControl = new FormControl(moment());

  maxDate: Date = new Date();

  private langSubscription: Subscription;

  constructor(
    private dateAdapter: DateAdapter<any>,
    private languageService: LanguageService
  ) {
    this.langSubscription = this.languageService.currentLanguage$.subscribe(lang => {
      this.dateAdapter.setLocale(lang);
      moment.locale(lang); // Actualizar locale de moment
    });

    // Inicializar con el idioma actual
    const currentLang = this.languageService.getCurrentLanguage();
    this.dateAdapter.setLocale(currentLang);
    moment.locale(currentLang);
  }

  ngOnInit() {
    this.startMonthControl = new FormControl(moment(), [Validators.max(this.maxDate.getTime())]);
    this.endMonthControl = new FormControl(moment(), [Validators.max(this.maxDate.getTime())]);
  }

  ngOnDestroy() {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }

  setStartMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    const startValue = this.startMonthControl.value!;
    startValue.month(normalizedMonthAndYear.month());
    startValue.year(normalizedMonthAndYear.year());
    this.startMonthControl.setValue(startValue);
    datepicker.close();
    this.emitMonthRange();
  }

  setEndMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    const endValue = this.endMonthControl.value!;
    endValue.month(normalizedMonthAndYear.month());
    endValue.year(normalizedMonthAndYear.year());
    this.endMonthControl.setValue(endValue);
    datepicker.close();
    this.emitMonthRange();
  }

  emitMonthRange() {
    if (this.startMonthControl.value && this.endMonthControl.value) {
      const start = new Date(this.startMonthControl.value.year(), this.startMonthControl.value.month(), 1);
      const end = new Date(this.endMonthControl.value.year(), this.endMonthControl.value.month(), 1);
      this.monthRangeSelected.emit({ start, end });
    }
  }
}
